/* ============
 * Filesize js
 * ============
 *
 * filesize.js provides a simple way to get a human readable file size string
 * from a number (float or integer) or string.
 *
 * https://github.com/avoidwork/filesize.js
 */

import filesize from 'filesize';

export default filesize;
